import React        from 'react'

const Content = props => {
    return (
        <div className="blogs-details-container-content">
            { props.children }
        </div>
    )
}

export default Content
